import { ManageSubjectWrapper } from "../../../Styles/ModalStyle";

const ManageSubjectModal = ({ isManageSubjectModalOpen, setIsManageSubjectModalOpen }) => {
    const closeModal = () => {
        setIsManageSubjectModalOpen(false);
    };

    return(
        <>
            <ManageSubjectWrapper className={isManageSubjectModalOpen ? "active" : ""}>
                <div className={`modal_box ${isManageSubjectModalOpen ? "active" : ""}`}>
                    <div className="modal_head">
                        <h4>Manage students of 10 - d for math</h4>
                        <div className="close_sec">
                            <a onClick={closeModal}><i className="fa-solid fa-angle-right"></i></a>
                        </div>
                    </div>
                    <div className="table_sec">
                        <div className="sec_inner">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Student Name</th>
                                        <th>Enrollment Number</th>
                                        <th>Attendance</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <div className="left_table_sec">
                                                <h5>JB</h5>
                                            </div>
                                            <div className="right_table_sec">
                                                <h6>Joydeep Barik</h6>
                                            </div>
                                        </td>
                                        <td>100</td>
                                        <td>
                                            <div className="toggle_bar">
                                                <input
                                                    type="checkbox"
                                                    id="toggle"
                                                />
                                                <label htmlFor="toggle">
                                                    <span></span>
                                                </label>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="left_table_sec">
                                                <h5>JB</h5>
                                            </div>
                                            <div className="right_table_sec">
                                                <h6>Joydeep Barik</h6>
                                            </div>
                                        </td>
                                        <td>100</td>
                                        <td>
                                            <div className="toggle_bar">
                                                <input
                                                    type="checkbox"
                                                    id="toggle"
                                                />
                                                <label htmlFor="toggle">
                                                    <span></span>
                                                </label>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="modal_btn">
                        <button>Cancel</button>
                        <button>Save Changes</button>
                    </div>
                </div>
            </ManageSubjectWrapper>
        </>
    );
}

export default ManageSubjectModal;